import React from 'react';

import {WindAvatar} from 'ccm/art/MedicalIcons';

import VitalCard from './VitalCard';

export default function RespirationCard({patient, artifact}) {
    return (
        <VitalCard
            color='blue'
            Avatar={WindAvatar}
            type='respirations'
            patient={patient}
            {...artifact.attributes}
        >
            <h6>Respiration rate</h6>
        </VitalCard>
    );
}
